module.exports = __webpack_public_path__ + "static/media/online.7edad359.svg";